/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "./Globals";


export function qget(loc, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
    }).then(async (r) => {
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        if (errorCallback)
            errorCallback(e);
    });
}

export async function qgetAsync(loc) {
    return new Promise((resolve, reject) => {
        fetch(Globals.serverUrl + loc, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        }).then(async (r) => {
            try {
                var j = await r.json();
                resolve(j);
            }
            catch (e) {
                reject(e);
            }
        }, (e) => {
            reject(e);
        });
    });

}

export function qpost(loc, data, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(async (r) => {
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        if (errorCallback)
            errorCallback(e);
    });
}

export async function qpostAsync(loc, data, signal) {
    return new Promise((resolve, reject) => {
        fetch(Globals.serverUrl + loc, {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            signal: signal
        }).then(async (r) => {
            try {
                var j = await r.json();
                resolve(j);
            }
            catch (e) {
                reject(j);
            }
        }, (e) => {
            reject(e);
        });
    });
}

export function qpostform(loc, data, successCallback, errorCallback) {
    fetch(Globals.serverUrl + loc, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: data
    }).then(async (r) => {
        try {
            var j = await r.json();
            if (successCallback)
                successCallback(j);
        }
        catch (e) {
            if (errorCallback)
                errorCallback(e);
        }
    }, (e) => {
        if (errorCallback)
            errorCallback(e);
    });
}

export async function qpostformAsync(loc, data, progressCallback) {
    return new Promise((resolve, reject) => {
        try {
            const xhr = new XMLHttpRequest();

            xhr.withCredentials = true

            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    if(progressCallback) {
                        progressCallback(percentComplete);
                    }
                }
            });
            
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    resolve(JSON.parse(xhr.responseText));               
                }
            };

            xhr.open('POST', Globals.serverUrl + loc, true);
            xhr.send(data);

        }
        catch (e) {
            console.error(e);
            reject(e);
        }
    });
}

function qstatus(loc, j, successCallback, errorCallback) {
    qget(loc + '/task/' + j.item, k => {
        if (k.errorCode === 0) {
            if (k.item.status === 1000) {
                console.log('task success');
                successCallback(k);
            }
            else if (k.item.status !== 1001 && k.item.status !== 1002) {
                console.log('task error');
                errorCallback(k);
            }
            else {
                setTimeout(() => qstatus(loc, j, successCallback, errorCallback), 1000);
            }
        }
        else {
            errorCallback(k);
        }
    });
}

export async function qtaskAsync(loc, data) {
    return new Promise(async (resolve, reject) => {
        try {
            let j = await qpostAsync(loc, data);
            if (j.errorCode === 0) {
                qstatus(loc, j, k => resolve({ item: k.item.payload, errorCode: 0 }), e => reject(e));
            }
            else
                reject(j);
        }
        catch (e) {
            reject(e);
        }
    });
}

export const qreq = {
    get: qget,
    post: qpost,
    getAsync: qgetAsync,
    postAsync: qpostAsync,
    postform: qpostform,
    postformAsync: qpostformAsync,
    taskAsync: qtaskAsync
};

